import { cn } from '@/shared/ui/cn'
import { StorageImage } from './storage-image'
import { deriveInitials } from './derive-initials'

type OrgBadgeCircleVariant = 'ring' | 'plain'

type OrgBadgeCircleProps = {
  badgeUrl?: string | null
  orgName: string
  isActive?: boolean
  size?: number
  variant?: OrgBadgeCircleVariant
  className?: string
}

export function OrgBadgeCircle({
  badgeUrl,
  orgName,
  isActive = false,
  size = 32,
  variant = 'ring',
  className,
}: OrgBadgeCircleProps) {
  const isPlain = variant === 'plain'
  const initials = isPlain
    ? deriveInitials(orgName)
    : orgName.trim().charAt(0).toUpperCase() || 'B'

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full font-display font-bold',
        isPlain
          ? 'border text-2xl'
          : cn(
              'border-2',
              isActive
                ? 'border-primary shadow-[0_0_0_2px_var(--blaze-soft)]'
                : 'border-input',
            ),
        badgeUrl ? 'bg-transparent' : 'bg-muted text-primary',
        className,
      )}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...(isPlain ? {} : { fontSize: `${Math.round(size * 0.45)}px` }),
      }}
      aria-hidden={isPlain ? undefined : 'true'}
    >
      {badgeUrl ? (
        <StorageImage
          src={badgeUrl}
          alt={isPlain ? orgName : `${orgName} badge`}
          width={size}
          height={size}
          className="h-full w-full object-cover"
        />
      ) : (
        initials
      )}
    </div>
  )
}
